<template>
    <div>
        <custom-cascader 
            v-if="collaborators.length > 0" 
            multiple 
            :placeholder="placeholder" 
            @input="selectCollaborator" 
            v-model="selected" 
            :options="collaborators"/>
    </div>
</template>
<script>
import CustomCascader from 'vcomponents/utilities/CustomCascader.vue';
export default {
    props: {
        collaborators : {
            type: Array,
            required: false,
            default: () => []
        },
        selectedCollaborator : {
            type: Array,
            required: false,
            default: () => []
        },
        placeholder : {
            type: String,
            required: false,
            default: () => this.$l10n.__('Sélectionner un collaborateur')
        }
    },
    data() {
        return {
            selected: []
        }
    },
    created() {
        this.selected = this.selectedCollaborator
        if(this.selected.length) {
            this.selectCollaborator(this.selected);
        }
    },
    methods: {
        /**
         * On Collaborator select, format values for filters engine and apply them.
         * @values: [id, id, id]
         */
        selectCollaborator(values) {
            let choices = [];
            let subChoices = values;

            values.forEach(collab => choices.push(this.findGroup(collab)));
            choices = [...new Set(choices.flat())]

            this.$emit('input', choices, subChoices);
        },

        findGroup(collabId) {
            return this.collaborators.filter(group => !!group.children.find(collab => collab.value === collabId)).map(group => group.value);
        }
    },
    components: {
        CustomCascader,
    }
}
</script>
